import { render } from "./MapConfig.vue?vue&type=template&id=588fe61a&scoped=true"
import script from "./MapConfig.vue?vue&type=script&lang=js"
export * from "./MapConfig.vue?vue&type=script&lang=js"

import "./MapConfig.vue?vue&type=style&index=0&id=588fe61a&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588fe61a"]])

export default __exports__